import React from 'react'
import  {CanceledVisasTable} from '../../components/table/CanceledVisasTable/canceled-visas-table'
export const CanceledVisas = () => {
  return (
    <div className='h-auto'>
        <CanceledVisasTable defaultValue={undefined} editItem={undefined}/>
    </div>
  )
}
